import { FeaturedPostCard } from 'components/Blog'
import { CoverBackground } from 'components/CoverBackground'
import { useBlogPostsQuery } from 'hooks/useBlogPostsQuery'
import { ComponentType } from 'react'

interface Props {
  thumbnailUrl: string
  name: string
}

export const Thanks: ComponentType<Props> = ({ name, thumbnailUrl }) => {
  const { data } = useBlogPostsQuery({
    variables: { query: { limit: 1 } },
  })

  const [post] = data?.blogPosts.posts ?? []

  return (
    <div>
      <h5 className="mb-25 font-family-serif text-center font-size-17 font-weight-bold text-primary">
        Gracias por contactarnos
      </h5>
      <CoverBackground
        url={thumbnailUrl}
        className="mb-25 w-150px h-150px mx-auto rounded-circle"
      />
      <p>
        Hola, soy{' '}
        <strong>
          {name}
        </strong>{' '}
        y te estaré contactando en breve.
      </p>
      <p className="mb-35">Te invito a leer este post de nuestro blog:</p>
      {post && <FeaturedPostCard post={post} className="mb-35" compact />}
      <p className="mb-10 font-size-14 text-gray-chateau font-weight-bold">Horario de oficina</p>
      <p className="mb-0 font-size-14 text-gray-chateau">
        Nuestros Asesores Premier están disponibles de lunes a sábado de 8:00 am a 7:30 pm; sin embargo, podrían
        contactarte fuera de este horario.
      </p>
    </div>
  )
}
